import { useFormikContext } from 'formik';

import { KubernetesSecurityFormValues } from './types';
import { SecuritySection } from './SecuritySection';
import { PodSecurityConstraintsSection } from './PodSecurityConstraintsSection';
import { ConstraintsSection } from './ConstraintsSection';

export function KubernetesSecurityFormFields() {
  const { values } = useFormikContext<KubernetesSecurityFormValues>();

  return (
    <>
      <SecuritySection />

      <PodSecurityConstraintsSection />

      {values.enablePodSecurityConstraints && <ConstraintsSection />}
    </>
  );
}
